import React, {useState, Fragment, useEffect} from 'react';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { Card, CardContent, Grid, Icon, Typography} from '@mui/material';
import TituloConIcono from 'components/tituloConIcono';
import { TablaPersonalizada } from 'components';
import { NoAutorizado } from 'commons';
import { functions } from 'constantes';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import { useDispatch } from 'react-redux';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import Formulario from 'components/formulario';
import ModalConElementosHijo from 'components/Modales/ModalConElementosHijo';
import { Cancel, Save, Visibility } from '@mui/icons-material';
import useStyles from 'components/Modales/styles';
import Base64Pdf from 'components/base64pdf';
let datosDelRequerimiento = {};

const ConformidadDeEjecucionDelPlan = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [ordenesDeTransmision] = useState('ordenesDeTransmision');
    const [ordenesDeTransmisionPorMedio] = useState('ordenesDeTransmisionPorMedio');
    const [validarDatos, setValidarDatos] = useState({checkearAutorizacion: false, autorizado: true, cargando: true});
    const [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false);
    const [modalPresentarInconformidad, setModalPresentarInconformidad] = useState(false);
    const [modalAdjuntarDocumentoFirmado, setModalAdjuntarDocumentoFirmado] = useState(false);
    const [mostarDetalleDelRequerimiento, setMostarDetalleDelRequerimiento] = useState(false);
    const[base64Imagen, setBase64Imagen] = useState("");
    const[mostrarLogo, setMostrarLogo] = useState(false);
    const[mostrarConstanciaFirmada, setMostrarConstanciaFirmada] = useState(false);
    const[base64ConstanciaFirmada, setBase64ConstanciaFirmada] = useState("");

    const [encabezadoTabla] = useState([
        { title: 'No. de orden', field: 'id', cellStyle:{ maxWidth: '80px' }},
        { title: 'Organización Política', field: 'oganizacionesPoliticas', render: (rowData) => <div>{rowData?.oganizacionesPoliticas?.nombre || ""}</div> },
        { title: 'Nivel de Cobertura', field: 'nivelDeCobertura', render: (rowData) => <div>{rowData?.nivelDeCobertura?.descripcion || ""}</div> },
        { title: 'Tipo de Elección', field: 'tipoDeEleccion', render: (rowData) => <div>{rowData?.tipoDeEleccion?.eleccion || ""}</div> },
        { title: 'Estado Orden Transmisión', field: 'estadoOrdenTransmision', render: (rowData) => <div>{rowData?.estadoOrdenTransmision?.estado || ""}</div> },
        { title: 'Período de Requerimiento', field: 'rangosDeGeneracionDeOrdenes', render: (rowData) => <div>{rowData?.rangosDeGeneracionDeOrdenes?.fechaInicio || ""} - {rowData?.rangosDeGeneracionDeOrdenes?.fechaFinal || ""}</div> },
        { title: 'Medio de Comunicación', field: 'medioDeComunicacion', render: (rowData) => <div> {rowData?.medioDeComunicacion?.nombreConcatenado} </div> },
        { title: 'Modalidad del medio', field: 'medioDeComunicacion', render: (rowData) => <div> {rowData?.medioDeComunicacion?.tipoDeMedioDeComunicacion?.descripcion} </div> },
        { title: 'Fecha de creación', field: 'fechaCreacion', render: (rowData) => functions.FormatearFecha(rowData?.fechaCreacion || "")},
        { title: 'Acciones', field: 'accion',
      render: rowData=><div style={{minWidth: '100px'}}>
          {
              (<div>
                  <TooltipPersonalizado title="Ver archivo de orden" handleFunction={() => verDocumentoDeOrden(rowData)} icon="visibility" fontSize={30} />
                  {!rowData.documentoAcepta && (
                    <>
                      <TooltipPersonalizado title="Aceptar conformidad de ejecución del plan" handleFunction={() => validarConfirmidadDelPlan(rowData)} icon="assignment_turned_in_icon" fontSize={30} color="green" />
                    </>
                  )}
                  <TooltipPersonalizado title="Adjuntar constancia firmada digitalmente" handleFunction={() => adjuntarDocumentoFirmado(rowData)} icon="cloud_upload" fontSize={30} />
                  <TooltipPersonalizado title="Ver constancia firmada" handleFunction={() => verConstanciaFirmada(rowData)} icon="visibility" fontSize={30} />
                  <TooltipPersonalizado title="Descagar constancia firmada" handleFunction={() => descargarConstanciaFirmada(rowData)} icon="cloud_download" fontSize={30} />
              </div>)
          }
          </div>
      },
    ]);

    useEffect( () => {
        obtenerOrdenesDeRequerimiento()
    }, [])

    const descargarConstanciaFirmada = async (rowData) => {
      setCargandoSolicitud(true);

      const {medioDeComunicacion, oganizacionesPoliticas, tipoDeEleccion, id} = rowData;

      let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: ordenesDeTransmisionPorMedio, saveInStore: false, nombreDelMetodo: "obtenerArchivo/validado", parametro: rowData?.id}));

      setCargandoSolicitud(false);

      if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "Inconvenientes al obtener información del documento", "", '');
      if(!respuesta?.data ) return alertaPersonalizadaSwal(respuesta.error?.message || "No encontramos información del documento", "", '');

      functions.descargarBase64EnPDF(respuesta.data, `No. de orden ${id || ""}-${medioDeComunicacion?.nombreConcatenado || ""}-${oganizacionesPoliticas?.nombre || ""}-${tipoDeEleccion?.eleccion || ""}.pdf`)

      return alertaPersonalizadaSwal("La constancia firmada se ha descargado de forma automática", "", '');
    }

    const verDocumentoDeOrden = async (rowData) => {
        setCargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: ordenesDeTransmision, saveInStore: false, nombreDelMetodo: "obtenerArchivo/orden", parametro: rowData?.id}));

        setCargandoSolicitud(false);

        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "Inconvenientes al obtener información del documento", "", '');
        if(!respuesta?.data ) return alertaPersonalizadaSwal(respuesta.error?.message || "No encontramos información del documento", "", '');

        setBase64Imagen(respuesta.data)
        setMostrarLogo(true)
    }

    const cerrarModalDeImagen = () => setMostrarLogo(false)

    const verConstanciaFirmada = async (rowData) => {
      setCargandoSolicitud(true);

      let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: ordenesDeTransmisionPorMedio, saveInStore: false, nombreDelMetodo: "obtenerArchivo/validado", parametro: rowData?.id}));

      setCargandoSolicitud(false);

      if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "Inconvenientes al obtener información del documento", "", '');
      if(!respuesta?.data ) return alertaPersonalizadaSwal(respuesta.error?.message || "No encontramos información del documento", "", '');

      setBase64ConstanciaFirmada(respuesta.data)
      setMostrarConstanciaFirmada(true)
    }

    const cerrarModalConstanciaFirmada = () => setMostrarConstanciaFirmada(false)

    const obtenerOrdenesDeRequerimiento = async () => {
        try{
            setValidarDatos({checkearAutorizacion: true, autorizado: false, cargando: true});

            const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(ordenesDeTransmision,'listar');
            if (hasPermission.error) return setValidarDatos({checkearAutorizacion: false, autorizado: false,cargando: false});

                ServiciosDelAPI[ordenesDeTransmision].iniciarMetodoDeBusqueda.clear();
                ServiciosDelAPI[ordenesDeTransmision].iniciarMetodoDeOrden.clear();
                ServiciosDelAPI[ordenesDeTransmision].setearChangeMethodPagination({changePagination: true, methodName: "registros/ordenes"});
                ServiciosDelAPI[ordenesDeTransmision].iniciarMetodoDeOrden.addDesc("fechaCreacion");
                setValidarDatos({checkearAutorizacion: false, autorizado: true,cargando: false});
        }catch(exception){
            alertaPersonalizadaSwal( exception.message || 'No encontramos información. Intente recargar de nuevo.')
            setValidarDatos({checkearAutorizacion: false, autorizado: true,cargando: false});
        }
    }

    const validarConfirmidadDelPlan = (rowData) => {
      datosDelRequerimiento = rowData;
      setAlertaDeConfirmacion(true)
    }

    const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

    const accionDeAlertaDeConfirmacion = async () => {
      setAlertaDeConfirmacion(false);
      setCargandoSolicitud(true);

      const datosAEnviar = { controller: ordenesDeTransmision, action: "crear", data: {}, nombreDelMetodo: `crear/aceptacionDeOrden/${datosDelRequerimiento?.id}`};

      const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
      setCargandoSolicitud(false);
      
      if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "No se pudó realizar la acción", "", '');

      alertaPersonalizadaSwal(respuesta?.data?.data || "Registro ingresado correctamente", "", 'success');
      functions.descargarBase64EnPDF(respuesta.data, "constancia_de_conformidad_de_transmision.pdf")

      obtenerOrdenesDeRequerimiento()
    }

    const [camposDelFormulario] = React.useState({
      alertaInformativa:{
        idelement: "alertaInformativa", mensaje: "ESCRIBIR: La fecha (del/los) spot publicitario(s) que corresponda a la presente orden de transmisión, con el (cual/cuales), NO SE ESTÁ CONFORME, y el motivo.", elementType:'alerta', showAlertForm: true, name: "alertaTarifa", value: "", isError:false, severity: 'warning'
      },
      descripcionDeInconformidad:{
          idelement: "descripcionDeInconformidad", value: "", label: `Describa el motivo de su inconformidad`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,300}$", validators: ['required'],
          errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionDeInconformidad", width: '100%'
      },
      acciones:{
          idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
      },
    });

    const rechazarConfirmidadDelPlan = (rowData) => {
      datosDelRequerimiento = rowData
      setModalPresentarInconformidad(true)
    }

    const cerrarModalPresentarInconformidad = () => setModalPresentarInconformidad(false)

    const deshabilitarOHabilitarPartidoPolitico = async (formData) => {
      setCargandoSolicitud(true);
      setModalPresentarInconformidad(false)
      setAlertaDeConfirmacion(false);
      const datosAEnviar = { controller: ordenesDeTransmision, action: "crear", data: {
        "idOrden": datosDelRequerimiento?.id || "",
        "motivoDeRechazo": formData?.descripcionDeInconformidad || ""
      }, nombreDelMetodo: `crear/rechazoOrden`};

      const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
      setCargandoSolicitud(false);

      if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "No se pudó realizar la acción", "", '');

      alertaPersonalizadaSwal("Registro ingresado correctamente", "La constancia se ha descargado automáticamente", 'success');

      functions.descargarBase64EnPDF(respuesta.data, "constancia_de_inconformidad_de_transmision.pdf")

      obtenerOrdenesDeRequerimiento();
    }

    const [buttonList]= React.useState({
      "saveData":{"label":"Sí, Guardar Datos", "icon": <Save />, "callback":deshabilitarOHabilitarPartidoPolitico,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
              isCancel: false,
      },
      "cancelAction":{"label":"No, Cancelar", "icon": <Cancel />,"callback":cerrarModalPresentarInconformidad,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
              isCancel: true,
      },
    });

    const [camposDelFormularioDocumento] = React.useState({
      constancia:{
        idelement: "constancia", value: "", label: "Constancia firmada (Máximo 10 MB)",
        validators: {required: true, size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled': false, name:"constancia", fileWidth: true, src: '/menu/Iconos Sistema SIDI_Mesa de trabajo 1 copia 23.png', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Constancia",   iconButton: <Visibility />, handleVisualization: undefined,  fileType: "pdf", nameOfFile: ""
      },
      acciones:{
          idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
      },
    });

    const adjuntarDocumentoFirmado = (rowData) => {
      datosDelRequerimiento = rowData
      setModalAdjuntarDocumentoFirmado(true)
    }

    const cerrarModalAdjuntarDocumento = () => setModalAdjuntarDocumentoFirmado(false)

    const actionAdjuntarDocumento = async (formData) => {
      setCargandoSolicitud(true);
      setModalAdjuntarDocumentoFirmado(false)

      const datosAEnviar = { controller: ordenesDeTransmision, action: "crear", data: {
        "idOrden": datosDelRequerimiento?.id || "",
        "archivoBase64": formData?.constancia || ""
      }, nombreDelMetodo: `crear/subirArchivo`};

      const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
      setCargandoSolicitud(false);

      if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "No se pudó realizar la acción", "", '');
      alertaPersonalizadaSwal(respuesta?.data || "Registro actualizado correctamente", "", 'success');
      camposDelFormularioDocumento.constancia.value=null;
      obtenerOrdenesDeRequerimiento();
    }

    const [buttonList2]= React.useState({
      "saveData":{"label":"Sí, Guardar Datos", "icon": <Save />, "callback":actionAdjuntarDocumento,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
              isCancel: false,
      },
      "cancelAction":{"label":"No, Cancelar", "icon": <Cancel />,"callback":cerrarModalAdjuntarDocumento,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
              isCancel: true,
      },
    });

    const actionMostrarRequerimiento = (rowData) => {
      datosDelRequerimiento = rowData
      setMostarDetalleDelRequerimiento(true);
    }
    const cerrarModalDeRequerimiento= () => setMostarDetalleDelRequerimiento(false);

    const {checkearAutorizacion, autorizado, cargando} = validarDatos;

    if (checkearAutorizacion ) return <IndicadorDeCarga open={cargando}/>
    if (!autorizado && !cargando){ return <NoAutorizado />}

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }

            <TituloConIcono title={"Conformidad de ejecución del plan"} mostrarTiempo={false} mostrarBotones={false} />
            <Card>
                <CardContent>
                    <TablaPersonalizada
                        service={ServiciosDelAPI[ordenesDeTransmision]}
                        title={"Listado "}
                        header={encabezadoTabla}
                        refreshList={obtenerOrdenesDeRequerimiento}
                        addRegister={undefined}
                        nameToolTipAdd={""}
                        pageSize={100}
                    />
                </CardContent>
            </Card>
            {alertaDeConfirmacion && (
                <ModalDeConfirmacion
                    title={`Su plan de medios se ejecuta conforme al requerimiento de transmisión anterior`} message={""}
                    open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion}
                    actionAdd={accionDeAlertaDeConfirmacion}
                    showSecondButton={true}
                    actionAdd2={() => setModalPresentarInconformidad(true)}
                    titleButton2={"No, estoy conforme, presentar disensión"}
                    titleButton={"Sí, estoy conforme"}
                />
            )}
             {modalPresentarInconformidad && (
              <ModalConElementosHijo
                    open={modalPresentarInconformidad}
                    closeModal={cerrarModalPresentarInconformidad}
                >
                    <CardContent>
                        <Grid container justifyContent="center" alignItems="center" spacing={1} >
                            <Icon color={"primary"} className={classes.icon} > errorOutline </Icon>
                            <Typography className={classes.title} > {`¿Está seguro de presentar inconformidad de ejecución del plan con el medio de comunicación ${datosDelRequerimiento?.medioDeComunicacion?.nombreConcatenado} ?`} </Typography>
                            <Formulario
                                elements={camposDelFormulario}
                                buttonList={buttonList}
                            />
                        </Grid>
                    </CardContent>
              </ModalConElementosHijo>
            )}
            {modalAdjuntarDocumentoFirmado && (
              <ModalConElementosHijo
                    open={modalAdjuntarDocumentoFirmado}
                    closeModal={cerrarModalAdjuntarDocumento}
                >
                    <CardContent>
                        <Grid container justifyContent="center" alignItems="center" spacing={1} >
                            <Typography className={classes.title} > ¿Está seguro de adjuntar el requerimiento validado y firmado electrónicamente con firma digital? </Typography>
                            <Formulario
                                elements={camposDelFormularioDocumento}
                                buttonList={buttonList2}
                            />
                        </Grid>
                    </CardContent>
              </ModalConElementosHijo>
            )}
            
            {mostrarLogo && (
                <Base64Pdf pdf={base64Imagen} title={"Archivo de orden"} open={mostrarLogo} handleClose={cerrarModalDeImagen}  showDownloadButton={true} src={base64Imagen} />
            )}

            {mostrarConstanciaFirmada && (
                <Base64Pdf pdf={base64ConstanciaFirmada} title={"Constancia firmada"} open={mostrarConstanciaFirmada} handleClose={cerrarModalConstanciaFirmada} showDownloadButton={true} src={base64ConstanciaFirmada} />
            )}
      </Fragment>
    );
}

export default ConformidadDeEjecucionDelPlan;